import { useOrganization } from 'hooks/store';
import { useFeatureFlags } from 'utils/features';

export default function useMultiEquipmentTrackingEnabled() {
  const { trackEquipment, multiEquipmentTracking } = useOrganization();
  const featureFlag = useFeatureFlags('MULTI_EQUIPMENT_TRACKING');

  return trackEquipment === true && multiEquipmentTracking === true && featureFlag;
}